<template>
    <div class="modal fade text-left" id="eventModal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="newEvent">{{ $t("labels.event") }} - Type: {{ translatedEventType($store.state.currentEvent.type) }} </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                   <form class="form">
                    <event-form :event="$store.state.currentEvent" v-on:updatedmediaevent="updateMedia" :type-list="typeList" ref="eventForm" v-bind:typeId.sync="typeId" :is-new="false"></event-form>
                    <div class="form-actions">
                      <button type="button" class="btn btn-success" @click.prevent="updateEvent($refs.eventForm.clonedEvent)">
                          <i class="icon-note"></i> {{ $t("labels.save") }}
                      </button>
                      <button type="button" class="btn btn-warning" @click.prevent="deleteEvent">
                        <i class="icon-note"></i> {{ $t("labels.delete") }}
                      </button>
                    </div>
                   </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal" ref='closeNewEventModal'>{{ $t("labels.close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LovService from '@/services/lov'
import EventService from '@/services/event'
import LovForm from '@/components/lov/LovForm'
import Progress from '@/components/patient/Progress'
import EventForm from '@/components/patient/EventForm'
import moment from 'moment'
import Swal from 'sweetalert2'

export default {
    props: ["event","patient","event_type"],
    components: {
        Progress,
        LovForm,
        EventForm
    },
    data() {
        return {
            errors: [],
            types: ['health_state','event'],
            typeList: [],
            typeId: '',
            lov: {
                name: {},
                type: 'event',
                userId: this.$store.state.user._id
            },
            video: {},
            image: {},
            showLovForm: false,
            otherText: ''
        }
    },
    computed: {
        typeValue() {
            let result = this.typeList.find(t => t._id === this.typeId)
            let tpval = {}
            if (this.typeId != 'other') {
                tpval.id = result._id
                tpval.type = result.type
                tpval.name = result.name
            } else {
                tpval.id = 'other'
                tpval.type = 'other'
                tpval.name = {'en': 'Other'}
                tpval.other = this.otherText
            }
            return tpval
        },
        showLovText() {
            if (this.showLovForm) {
                return this.$t("labels.hideEventForm")
            } else {
                return this.$t("labels.addUserLov")
            }
        }
    },
    methods: {
      translatedEventType: function(eventType){
        return this.$t(`lovTypes.${eventType}`)
      },
      
      getValues: async function(tp) {
        let result = await LovService.all(tp, false)
        if (result) {
            this.typeList = result.data.filter(function (lv) {
                return lv.userId === undefined || lv.userId === this.$store.state.user._id
            })
        }
        this.typeList = result.data
      },
      updateMedia: async function(updatedEvent) {
        let self = this
        let currentEvent = updatedEvent
        const allowedVideoTypes = ['video/mp4','video/x-flv','video/quicktime','video/3gpp','video/x-msvideo','video/x-ms-wmv']
        if (currentEvent.video && currentEvent.video.type) {
            if (!allowedVideoTypes.includes(currentEvent.video.type)) {
                this.errors.push(this.$t("errors.wrongFiletype", [currentEvent.video.name]))
            }
            let videSizeMb = currentEvent.video.size/1024/1024
            if (videSizeMb > 50 ) {
                this.errors.push(this.$t("errors.tooLarge", [currentEvent.video.name]))
            }
        }
        const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif']
        if (currentEvent.image && currentEvent.image.type) {
            if (!allowedImageTypes.includes(currentEvent.image.type)) {
                this.errors.push(this.$t("errors.wrongFiletype", [currentEvent.image.name]))
            }
            let imageSizeMb = currentEvent.image.size/1024/1024
            if (imageSizeMb > 5) {
                this.errors.push(this.$t("errors.tooLarge", [currentEvent.image.name]))
            }
        }
        let formData = new FormData()
        formData.append('video', currentEvent.video)
        formData.append('image', currentEvent.image)
        formData.append('event', JSON.stringify(currentEvent))
        let result = await EventService.updateMedia(formData)

        if (result) {
          self.$miniToastr.success(self.$t("flash.updateSuccess", [self.$t("models.event")]))
          self.$store.state.currentEvent = result.data.event
        } else {
          self.$miniToastr.error(self.errors.toString().split(",").join("<hr/>"))
        }
      },
      updateEvent: async function(updatedEvent) {
        let self = this
        let loader = this.$loading.show({
            color: '#ccc',
            loader: 'spinner'
        },{
            after: this.$createElement('Progress')
        })
        this.errors = []
        let currentEvent = updatedEvent
        if (!currentEvent.startDate) {
            this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.startDate")]))
        }
        if (!currentEvent.type) {
            this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.eventType")]))
        }
        if (!this.typeId) {
            this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.typeValue")]))
        }
        if (currentEvent.periodic === true) {
            if (!currentEvent.dailyStart) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dailyStart")]))
            }
            //if (!currentEvent.dailyEnd) {
            //    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dailyEnd")]))
            //}
            if (currentEvent.periodStep === 'weeks') {
                if (!currentEvent.dayOfWeek) {
                    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dayOfWeek")]))
                }
            }
            if (currentEvent.periodStep === 'months') {
                if (!currentEvent.dayOfMonth) {
                    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dayOfMonth")]))
                }
            }
        }
        if (this.errors.length === 0) {
          currentEvent.typeValue = this.typeValue
          let result
          if (currentEvent.shortId != null) {
            Swal.fire({
              title:  self.$t('labels.youAreModifyingPeriodicEvent'),
              text: self.$t('labels.continueModifyingPeriodicEvent'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#0CC27E',
              cancelButtonColor: '#FF586B',
              confirmButtonText: self.$t('labels.confirmModifiyingPeriodicEvent'),
              cancelButtonText: self.$t('labels.cancelModifiyingPeriodicEvent')
            }).then(async function (isConfirm) {
              if (isConfirm) {
                if (isConfirm.dismiss == 'backdrop')
                  return false
                if (isConfirm.dismiss == 'cancel')
                  result = await EventService.update(currentEvent)
                if (isConfirm.value)  
                  result = await EventService.updatePeriodic(currentEvent)
              }
              if (result) {
                self.$miniToastr.success(self.$t("flash.updateSuccess", [self.$t("models.event")]))
                self.$store.state.currentEvent = {}
                
                self.$emit('refreshevents', currentEvent.type)
                self.$refs.closeNewEventModal.click()
              } else {
                self.$miniToastr.error(self.errors.toString().split(",").join("<hr/>"))
              }
              loader.hide()
            }).catch(Swal.noop);
          }else {
            result = await EventService.update(currentEvent)
            if (result) {
              self.$miniToastr.success(self.$t("flash.updateSuccess", [self.$t("models.event")]))
              self.$store.state.currentEvent = {}
              self.$emit('refreshevents', currentEvent.type)
              self.$refs.closeNewEventModal.click()
            } else {
              self.$miniToastr.error(self.errors.toString().split(",").join("<hr/>"))
            }
            loader.hide()
            this.$store.state.currentProgress = 0
          }
        } else {
          this.$miniToastr.error(self.errors.toString().split(",").join("<hr/>"))
          loader.hide()
        }
        
      },
      deleteEvent: async function () {
        let self = this
        let currentEvent = this.$store.state.currentEvent
        let result
        let loader = this.$loading.show({
            color: '#ccc',
            loader: 'spinner'
        },{
            after: this.$createElement('Progress')
        })
        if (currentEvent.shortId != null) {
          Swal.fire({
            title:  self.$t('labels.youAreModifyingPeriodicEvent'),
            text: self.$t('labels.continueModifyingPeriodicEvent'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: self.$t('labels.confirmModifiyingPeriodicEvent'),
            cancelButtonText: self.$t('labels.cancelModifiyingPeriodicEvent')
          }).then(async function (isConfirm) {
            if (isConfirm) {
              if (isConfirm.dismiss == 'backdrop')
                return false
              if (isConfirm.dismiss == 'cancel')
                result = await EventService.delete(currentEvent)
              if (isConfirm.value)  
                result = await EventService.deletePeriodic(currentEvent)
              
              if (result) {
                self.$miniToastr.success(self.$t("flash.updateSuccess", [self.$t("models.event")]))
                self.$emit('refreshevents', currentEvent.type)
                self.$refs.closeNewEventModal.click()
              } else {
                self.$miniToastr.error(self.errors.toString().split(",").join("<hr/>"))
              }
              loader.hide()
              this.$store.state.currentProgress = 0
            }
          }).catch(Swal.noop);
        }else {
          result = await EventService.delete(currentEvent)
          if (result) {
            self.$miniToastr.success(self.$t("flash.updateSuccess", [self.$t("models.event")]))
            self.$emit('refreshevents', currentEvent.type)
            self.$refs.closeNewEventModal.click()
          } else {
            self.$miniToastr.error(self.errors.toString().split(",").join("<hr/>"))
          }
           loader.hide()
           this.$store.state.currentProgress = 0
        }
      },
    }
}
</script>
